<dx-scroll-view #scrollView class="container chat-log-container" width="100%">
  <ng-container *ngFor="let chatMessage of chatMessages; trackBy: trackByChatMessage">
    <nida-web-chat-message [chatMessage]="chatMessage"></nida-web-chat-message>
  </ng-container>
</dx-scroll-view>
